<template>
  <div class="timeSwitch">
    <div v-for="(item,index) in mSwitchTags" :class="{active:index === currentIndex}" :key="index"
         @click="btSwitch(item,index)">{{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "mSwitch",
  props: {
    mSwitchTags: {
      type: Array,
      default: () => [
        {
          name: '已选时间',
          time: null
        },
        {
          name: '近一周',
          time: 7
        },
        {
          name: '近一月',
          time: 30
        }
      ]
    },
    switchIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    switchIndex: {
      handler(val) {
        this.currentIndex = val
      },
      immediate: true
    },
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  methods: {
    btSwitch(item, index) {
      if (this.currentIndex !== index){
        this.currentIndex = index
        this.$emit('change', item)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.timeSwitch {
  height: 32px;
  border-radius: 16px;
  background: linear-gradient(180deg, #F3F5F7 0%, #F3F5F7 9.91%, #FEFEFF 100%);
  border: 1px solid #FFFFFF;
  box-shadow: -4px -4px 10px 0px #FFFFFF, 4px 4px 10px 0px #DEDDE3;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-weight: 500;
  padding: 1px;
  font-size: 12px;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 60px;
    height: 26px;
    border-radius: 13px;
    transition: .4s;
    white-space: nowrap;
  }

  & > div.active {
    background: #7B8AB2;
    box-shadow: 2px 2px 4px 0 #7B8AB2;
    color: white;
    cursor: default;
  }

  & > div:not(.active) {
    color: #7B8AB2;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mSwitch.vue